import clienteHttp from "../service/ClienteHttps";

const API_URL = clienteHttp.defaults.baseURL;

export async function obtenerTurnosMedico(
  idMedico,
  especialidades = [],
  nombrePacienteBusqueda = ""
) {
  if (!idMedico) {
    throw new Error("Falta el ID del médico");
  }

  const params = new URLSearchParams();

  if (especialidades.length === 1) {
    params.append("especialidad", especialidades[0]);
  }

  if (nombrePacienteBusqueda.trim()) {
    params.append("paciente", nombrePacienteBusqueda.trim());
  }

  const queryString = params.toString();

  const url =
    `${API_URL}/turnos/medico/${idMedico}` +
    (queryString ? `?${queryString}` : "");
   

  const response = await fetch(url, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    const respuestaError = await response.json().catch(() => null);

    throw new Error(
      respuestaError?.error ||
      "No se pudieron cargar los turnos del médico"
    );
  }

  const datos = await response.json();

  return Array.isArray(datos) ? datos : [];
}

export async function aceptarTurnoMedico(idMedico, idTurno) {
  const response = await fetch(
    `${API_URL}/medicos/${idMedico}/turnos/${idTurno}/aceptar`,
    {
      method: "PUT",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );

  const datos = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(
      datos?.error ||
      datos?.message ||
      "No se pudo confirmar el turno"
    );
  }

  return datos;
}

export async function confirmarCambioFecha(idMedico, idTurno) {
  const response = await fetch(
    `${API_URL}/medicos/${idMedico}/turnos/${idTurno}/confirmar-cambio`,
    {
      method: "PUT",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );

  const datos = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(datos?.error || datos?.message || "No se pudo confirmar el cambio");
  }

  return datos;
}

export async function rechazarCambioFecha(idMedico, idTurno) {
  const response = await fetch(
    `${API_URL}/medicos/${idMedico}/turnos/${idTurno}/rechazar-cambio`,
    {
      method: "PUT",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        motivoRechazo: "Rechazado por el médico",
      }),
    }
  );

  const datos = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(datos?.error || datos?.message || "No se pudo rechazar el cambio");
  }

  return datos;
}

export async function cancelarTurnoMedico(
  idMedico,
  idTurno,
  motivo
) {
  const response = await fetch(
    `${API_URL}/medicos/${idMedico}/turnos/${idTurno}/cancelar`,
    {
      method: "PUT",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ motivo }),
    }
  );

  const datos = await response.json();

  if (!response.ok) {
    throw new Error(datos.error || "No se pudo cancelar el turno");
  }

  return datos;
}

export async function marcarRealizadoMedico(idMedico, idTurno) {
  const response = await fetch(
    `${API_URL}/medicos/${idMedico}/turnos/${idTurno}/realizar`,
    {
      method: "PUT",
      credentials: "include",
    }
  );

  const datos = await response.json();

  if (!response.ok) {
    throw new Error(
      datos.error || "No se pudo marcar el turno como realizado"
    );
  }

  return datos;
}

export async function proponerCambioMedico(
  idMedico,
  idTurno,
  fecha,
  hora
) {
  const nuevaFechaHora = `${fecha}T${hora}:00`;

  const response = await fetch(
    `${API_URL}/medicos/${idMedico}/turnos/${idTurno}/proponer-cambio`,
    {
      method: "PUT",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        nuevaFechaHora,
      }),
    }
  );

  const datos = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(
      datos?.error ||
        datos?.message ||
        "No se pudo enviar la propuesta de cambio"
    );
  }

  return datos;
}